/** @type {import("@mui/material").SxProps<Theme>} */
// import getConfig from 'next/config';

// const { publicRuntimeConfig } = getConfig();

const styles = (theme, backgroundImage) => ({
  PrequalContainer: {
    height: '13.75rem',
    pt: '0 !important',
    // marginTop: '1rem',
    position: 'relative',
    maxHeight: '21rem',
    [theme.breakpoints.down('md')]: {
      background: `url(${backgroundImage}) center top/100% 100% no-repeat`,
    },
    [theme.breakpoints.up('md')]: {
      background: `url(${backgroundImage}) center top/100% 100% no-repeat`,
      pl: '0 !important',
    },
  },
  BannerContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    minHeight: '13rem',
    flexDirection: 'row',
    height: '100%',
    // background: `url(${backgroundImage}) center top/100% 100% no-repeat`,

    [theme.breakpoints.down('sm')]: {
      minHeight: '18.44rem',
      justifyContent: 'flex-end',
      display: 'flex',
      flexDirection: 'column-reverse',
    },

    [theme.breakpoints.between('sm', 'md')]: {
      minHeight: '35rem',
      justifyContent: 'flex-end',
      display: 'flex',
      flexDirection: 'column-reverse',
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
      marginTop: '0rem',
    },
  },
  bannerTitle: {
    color: theme.palette.primary.textColor2,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: '5rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      marginTop: '4rem',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '0rem',
    },
  },
  bannerSubTitle: {
    color: theme.palette.secondary.contrastText,
    marginTop: '1rem',
    textAlign: 'center',
  },
  bannerCurve: {
    position: 'absolute',
    width: '100%',
    height: { xs: '2.75rem', sm: '2.875rem', lg: '4rem' },
    bottom: -1,
  },
  offerSlider: {
    swiper: {
      [theme.breakpoints.up('sm')]: {
        width: '100%',
      },
      [theme.breakpoints.up('md')]: {
        width: '100%',
        '& .swiper-pagination': {
          position: 'inherit',
        },
      },
      [theme.breakpoints.up('lg')]: {
        width: '73rem',
        '& .swiper-slide': {
          paddingRight: 0,
          paddingLeft: 0,
        },
      },

      '& .swiper-pagination-bullet-active': {
        backgroundColor: theme.palette.primary.buttonColor,
      },
      '& .content-carousel-broadband': {
        height: { xs: 'fit-content' },
        [theme.breakpoints.up('lg')]: {
          pl: 0,
          pr: 0,
        },
        [theme.breakpoints.down('sm')]: {
          pt: 3,
          pl: 2.25,
          pb: 9,
          pr: 2.25,
        },
        [theme.breakpoints.up('sm')]: {
          pt: 5,
          // pl: 3.75,
          pb: 11.5,
          // pr: 3.75,
        },
        [theme.breakpoints.up('md')]: {
          pt: 2,
          pl: 1.375,
          pb: 1,
          pr: 1.375,
        },
      },
      '& .content-carousel-broadband .swiper-slide': {
        paddingTop: '1rem',
        paddingBottom: '1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        [theme.breakpoints.up('lg')]: {
          '& .offer-card': {
            width: '22.5rem',
          },
        },
        [theme.breakpoints.up('md')]: {
          '& .offer-card': {
            width: 'unset',
          },
        },
        [theme.breakpoints.up('sm')]: {
          '& .offer-card': {
            width: '90%',
          },
        },
        [theme.breakpoints.down('sm')]: {
          '&.swiper-slide-active': {
            // transform: 'scale(1.1)',
            width: '100% !important',
            '& .offer-card': {
              width: 'inherit',
              // maxWidth: '70vw',
            },
          },
          '&.swiper-slide-prev': {
            transform: 'scale3d(0.95,0.95,0.80)',
          },
          '&.swiper-slide-next': {
            transform: 'scale3d(0.95,0.95,0.80)',
          },
        },
      },
    },
  },
  title: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
  prevArrow: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.errorCTA,
    '&.Mui-disabled': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.disableCTA,
    },
  },
  nextArrow: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.errorCTA,
    '&.Mui-disabled': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.disableCTA,
    },
  },
  offerCards: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '100%',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '91%',
    },
    width: { sm: '90vw', md: '100%', lg: '100%' },
    display: { md: 'flex' },
    justifyContent: { md: 'center' },
    alignItems: { md: 'center' },
    flexDirection: { md: 'row' },
  },
  mbbDeviceContainer: {
    margin: '0 auto',
    [theme.breakpoints.between('sm', 'md')]: {
      p: '1rem 5rem 0rem 5rem',
    },
  },
  submitCTAContainerMbbDevices: {
    display: 'flex',
    justifyContent: 'center',
    m: '1.5rem 0 0 0',
    [theme.breakpoints.down('md')]: {
      m: '1.5rem 2rem 0rem 2rem',
    },
    [theme.breakpoints.down('sm')]: {
      m: '1rem 2rem 0rem 2rem',
    },
  },
  submitCTAMbbDevices: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    fontColor: theme.palette.primary.buttonColor,
    border: `3px solid ${theme.palette.primary.buttonColor}`,
    borderRadius: '100px',
    textTransform: 'capitalize',
    width: '6.625rem',
    height: '40px',
    background: theme.palette.primary.buttonColor,
    color: theme.palette.secondary.contrastText,
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Lite},0px 10px 14px 1px ${theme.palette.primary.boxShadow1Lite},0px 4px 18px 3px ${theme.palette.primary.boxShadow1Lite}`,
    '&:hover': {
      border: `3px solid ${theme.palette.primary.buttonPrimaryHoverColor}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 6px 6px -3px  ${theme.palette.primary.boxShadow}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow}`,
    },
  },
  submitCTAMbbDevicesDisabled: {
    width: '6.625rem',
    padding: '0.3125rem',
    pointerEvents: 'none',
    minHeight: '2.5rem',
    textTransform: 'capitalize',
    '&.Mui-disabled': {
      background: theme.palette.primary.buttonInactiveColor,
      border: 'none',
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  faqContainerSuperMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '2rem',
    paddingBottom: '7rem',
    marginTop: '6.25rem',
  },
  mainContainerBox: {
    [theme.breakpoints.up('sm')]: {
      width: '53.375rem',
    },
    [theme.breakpoints.up('md')]: {
      width: '53.375rem',
    },
  },
  mainHeading: {
    color: theme.palette.primary.textColor3,
    letterSpacing: '0.25px',
    p: '2rem 0 2rem 1.5rem',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      p: '2rem 0 2rem 1rem',
    },
  },
  accordMain: {
    backgroundColor: theme?.palette.primary.backgroundColor3,
    boxShadow: 'none',
    minHeight: '58px',
    '&:before': {
      bottom: '0rem',
      top: 'unset',
      right: '1.25rem',
      [theme.breakpoints.down('sm')]: {
        position: 'relative',
      },
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0.5rem',
      paddingRight: '0.5rem',
    },
  },
  accordSummaryMain: {
    height: '55px',
    '& .MuiAccordionSummary-content': {
      margin: '17.95px 0px 14.05px 0px',
      paddingLeft: '8px',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '17.95px 0px 0px 0px',
    },
  },
  accordSummaryTitle: {
    color: theme.palette.primary.textColor3,
  },
});
export default styles;
